import { 
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  ContentChild,
  TemplateRef,
  ElementRef } from '@angular/core';
import { GalleryColumns } from 'src/app/gallery/models/gallery-list-columns.enum';
import { MatCheckboxChange } from '@angular/material';
import { BookmarkModel } from 'src/app/bookmarks/models/bookmark.model';

@Component({
  selector: 'app-gallery-card',
  templateUrl: './gallery-card.component.html',
  styleUrls: ['./gallery-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GalleryCardComponent implements OnInit {
  galleryColumns = GalleryColumns;

  @ContentChild('galleryActions', { read: TemplateRef }) 
  @Input()
  galleryActionsTemplate: TemplateRef<ElementRef>;

  @ContentChild('galleryTags', { read: TemplateRef }) 
  @Input()
  galleryTagsTemplate: TemplateRef<ElementRef>;
  

  @Input()
  selectLabel = 'Select';

  @Input()
  public get columns(): GalleryColumns[] {
    return this._columns;
  }
  public set columns(value: GalleryColumns[]) {
    this._columns = value;
  }
  private _columns: GalleryColumns[] = [
    GalleryColumns.Model,
    GalleryColumns.Tags,
    GalleryColumns.CreatedBy,
    GalleryColumns.UpdatedBy,
    GalleryColumns.Actions
  ];

  @Input()
  public get result(): BookmarkModel {
    return this._result;
  }
  public set result(value: BookmarkModel) {
    this._result = value;
    this.changeDetectorRef.markForCheck();
  }
  private _result: BookmarkModel;

  @Input()
  checkable = false;

  @Input()
  checked = false;

  @Input()
  showActions = false;

  @Output()
  selectBookmark = new EventEmitter<BookmarkModel>();

  @Output()
  checkedChange = new EventEmitter<{ id: string, checked: boolean }>();

  constructor(
    private changeDetectorRef: ChangeDetectorRef
  ) { }

  ngOnInit() {
  }

  hasColumns(...columns: GalleryColumns[]) {
    return columns.some((column) => this.hasColumn(column));
  }

  hasColumn(value: GalleryColumns) {
    return this.columns.some(column => column === value);
  }

  handleSelect(result: BookmarkModel) {
    this.selectBookmark.emit(result);
  }

  handleCheckedChange(event: MatCheckboxChange) {
    this.checkedChange.emit({ id: event.source.value, checked: event.checked });
  }
}
